export function calculateFd({ amount, rate, months, type }) {
  const principal = Number(amount) || 0;
  const annualRate = (Number(rate) || 0) / 100;
  const years = (Number(months) || 0) / 12;
  const maturity = principal + principal * annualRate * years;

  return {
    interest: maturity - principal,
    maturity
  };
}

export function calculateRd({ monthly, rate, months }) {
  const deposit = Number(monthly) || 0;
  const n = Number(months) || 0;
  const monthlyRate = (Number(rate) || 0) / 100 / 12;
  const totalDeposit = deposit * n;
  const maturity = monthlyRate > 0 ? deposit * ((Math.pow(1 + monthlyRate, n) - 1) / monthlyRate) : totalDeposit;
  return {
    totalDeposit,
    interest: maturity - totalDeposit,
    maturity
  };
}

export function calculateDaily({ daily, rate, days }) {
  const deposit = Number(daily) || 0;
  const tenureDays = Number(days) || 0;
  const totalDeposit = deposit * tenureDays;
  const interest = totalDeposit * ((Number(rate) || 0) / 100) * (tenureDays / 365);
  return {
    totalDeposit,
    interest,
    maturity: totalDeposit + interest
  };
}

export function calculateGold({ grams, purity, ltv }) {
  const marketRatePerGram24k = 6500;
  const purityFactor = (Number(purity) || 22) / 24;
  const eligible = (Number(grams) || 0) * marketRatePerGram24k * purityFactor * ((Number(ltv) || 70) / 100);
  return {
    eligible
  };
}
